require('tiny-slider/dist/tiny-slider.css');

import { tns } from 'tiny-slider/src/tiny-slider.module';

const defaultDelay = 5000;
const controller = {
    init: function () {
        const galleries = document.querySelectorAll('.js-gallery');
        const galleriesArray = [...galleries]

        galleriesArray.forEach(el => {
            const delay = el.dataset['delay'] && el.dataset['delay'] > 0
                ? el.dataset['delay'] * 1000
                : defaultDelay;

            tns({
                container: el,
                items: 1,
                autoplay: true,
                controls: false,
                nav: false,
                autoplayButtonOutput: false,
                autoplayTimeout: delay
            });
        })
    }
}

export default controller;


// WEBPACK FOOTER //
// ./Core/Panels/imageCarouselPanel/Js/index.js